<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

const props = defineProps<{
	class?: HTMLAttributes['class'];
}>();
</script>

<template>
	<div :class="cn('flex flex-col gap-y-1.5 p-7 px-9 pb-4 pt-9', props.class)">
		<slot></slot>
	</div>
</template>
